import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import InputMask from 'react-input-mask';

class Phone extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isEvent} = this.props;
    if(isEvent===true){
      changeHandler(e.target.value,e);
    }else{
      changeHandler(e.target.value);
    }
  } 

  preventNonNumericalInput = (e) =>{
    //if(props.isAllowNegative===true){
      e = e || window.event;
      let charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      let charStr = String.fromCharCode(charCode);
      
      if (!charStr.match(/^[0-9]+$/))
        e.preventDefault();
    //}
  };

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    let phoneNumberFormat ='';
    try{
      const userInfo = JSON.parse(localStorage.getItem('user_info'));
      phoneNumberFormat = userInfo.data.locale_phone_number_format;
      phoneNumberFormat = phoneNumberFormat.replace(/N/g, '9');
      phoneNumberFormat = phoneNumberFormat.replace(/X/g, '*');
    }catch(e){
      console.log('e',e);
    }
    return (
      <Wrp>
        <InputMask 
          {...this.props} 
          mask={phoneNumberFormat} 
          maskChar={""}//"" 
          value={value}
          onChange={e=>this.fieldOnChangeHandler(e)}
          {...attr}
          // placeholder={phoneNumberFormat}
          onKeyPress={e=>this.preventNonNumericalInput(e)}
        />
      </Wrp>        
    );
  }
}

Phone.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  isEvent:false
}

export default Phone;